"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDownloadUrlApiToken = exports.getSignedDocumentApiToken = exports.getPendingDocumentApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.getPendingDocumentApiToken = function (page, listOrderEnum, listOrderIsAsc, languageCode, token) {
    return Api_1.api().request({
        data: { page: page, listOrderEnum: listOrderEnum, listOrderIsAsc: listOrderIsAsc },
        method: 'POST',
        url: languageCode + "/api/mydocument/getpendingdocuments",
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getSignedDocumentApiToken = function (page, listOrderEnum, listOrderIsAsc, languageCode, token) {
    return Api_1.api().request({
        data: { page: page, listOrderEnum: listOrderEnum, listOrderIsAsc: listOrderIsAsc },
        method: 'POST',
        url: languageCode + "/api/mydocument/getsigneddocuments",
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getDownloadUrlApiToken = function (key, languageCode, token) {
    return Api_1.api().request({
        method: 'GET',
        url: languageCode + "/api/mydocument/getdownloadurl?key=" + key,
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
